// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__sCiyy","col":"CardReaderDesc_col__3-ae6","label":"CardReaderDesc_label__g4Shr"};